import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const SubmitAnswersRequest = z.object({
  agentId: z.string(),
  calibrationId: z.string(),
  answers: z.array(
    z.object({
      questionText: z.string(),
      selectedOption: z.string(),
    }),
  ),
})

export type SubmitAnswersRequest = z.infer<typeof SubmitAnswersRequest>

export const SubmitAnswersResponse = z.object({
  success: z.boolean(),
})

export type SubmitAnswersResponse = z.infer<typeof SubmitAnswersResponse>

export const submitAnswersDeclaration = endpointDeclaration(SubmitAnswersRequest, SubmitAnswersResponse)
